import { useState } from "react";

/** Password field with a Show/Hide toggle — one component for every password
 *  on the public surface (login, reset, account setup). Text toggle, not an
 *  icon: self-labeling and consistent with the typographic form voice. */
export function PasswordInput({
  value,
  onChange,
  autoComplete,
  autoFocus,
  required,
}: {
  value: string;
  onChange: (v: string) => void;
  autoComplete: "current-password" | "new-password";
  autoFocus?: boolean;
  required?: boolean;
}) {
  const [show, setShow] = useState(false);
  return (
    <div className="pw-field">
      <input
        type={show ? "text" : "password"}
        className="field-input pw-input"
        autoComplete={autoComplete}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoFocus={autoFocus}
        required={required}
      />
      <button
        type="button"
        className="pw-toggle"
        aria-pressed={show}
        aria-label={show ? "Hide password" : "Show password"}
        onClick={() => setShow((s) => !s)}
      >
        {show ? "Hide" : "Show"}
      </button>
    </div>
  );
}
